import React from 'react';

interface DeckPileProps {
  count: number;
  canDraw: boolean;
  onDraw: () => void;
}

export const DeckPile = React.memo(function DeckPile({ count, canDraw, onDraw }: DeckPileProps) {
  return (
    <div className="deck-area" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
      <span className="indicator-label">DESTE</span>
      <div
        className={`deck-pile${canDraw ? ' animate-pulse-gold' : ''}`}
        onClick={canDraw ? onDraw : undefined}
        role={canDraw ? 'button' : undefined}
        aria-label={canDraw ? 'Taş çek' : undefined}
        style={{ cursor: canDraw ? 'pointer' : 'default' }}
        title={canDraw ? 'Desteden çek' : `${count} taş kaldı`}
      >
        {/* Stacked visual tiles */}
        <div className="deck-tile" />
        <div className="deck-tile" />
        <div className="deck-tile" />
        <div className="deck-count">{count}</div>
      </div>
    </div>
  );
});

export default DeckPile;
